import React from "react";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import ProjectCard from "../../components/ProjectCard/ProjectCard";
import { Fade } from "react-reveal";
import { projectsHeader, projects } from "../../portfolio.js";
import "./Projects.css";
import ProjectsImg from "./ProjectsImg";
import { style } from "glamor";
import SocialMedia from "../../components/socialMedia/SocialMedia";

function Projects(props) {
  const theme = props.theme;

  const styles = style({
    backgroundColor: `${theme.accentBright}`,
    ":hover": {
      boxShadow: `0 5px 15px ${theme.accentBright}`,
    },
  });

  return (
    <div className="projects-main">
      <Header theme={theme} setTheme={props.setTheme} />
      <div className="basic-projects">
        <Fade bottom duration={2000} distance="40px">
          <div className="projects-heading-div">
            <div className="projects-heading-img-div">
              <img
                src={process.env.PUBLIC_URL + "/tjintro2.png"}
                alt="femaledev"
              />
            </div>
            <div className="projects-heading-text-div">
              <h1
                className="projects-heading-text"
                style={{ color: theme.text }}
              >
                {projectsHeader.title}
              </h1>
              <p
                className="projects-header-detail-text subTitle"
                style={{ color: theme.secondaryText }}
              >
                {projectsHeader["description"]}
              </p>
            </div>
          </div>
        </Fade>
      </div>
      <div className="repo-cards-div-main">
        {projects.data.map((repo) => {
          return <ProjectCard repo={repo} theme={theme} />;
        })}
      </div>
      <br />
      <br /> <br /> <br />
      <h1 className="project-title">Links</h1>
      <SocialMedia />
      <br />
      <div className="p-links">
        <a
          {...styles}
          className="general-btn"
          href={
            "https://docs.google.com/document/d/1ynV_1zy_xft9AksVl2PgOWIaoZhdda58O7SBqFG_0R0/edit#heading=h.5rf9wr4r3no2"
          }
        >
          See my Resume
        </a>
        <br /> <br /> <br />
        <a
          {...styles}
          className="general-btn"
          href={
            "https://www.etsy.com/shop/TojuDesignStudio?ref=seller-platform-mcnav"
          }
        >
          Etsy Shop
        </a>
      </div>
      <br />
      <br />
      <Footer theme={props.theme} onToggle={props.onToggle} />
    </div>
  );
}

export default Projects;
